import constant from "config/constant";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  dehydrate,
  fetchUserProfile,
  hydrateToken,
  selectAuth,
  updatePopUpShow,
} from "store/slices/auth.slice";
import ls from "util/secureStorage";

// let funcCallCount = 0;
const useAuth = () => {
  const dispatch = useDispatch();
  const { auth, profile } = useSelector(selectAuth);

  const refetchProfile = useCallback(
    (token) => {
      dispatch(fetchUserProfile(token));
    },
    [dispatch]
  );

  const login = useCallback(
    (token, exp, isSignedIn = true, verification = []) => {
      dispatch(hydrateToken({ token, exp, isSignedIn, verification }));
      // dispatch(fetchUserProfile(token));
      refetchProfile(token);
    },
    [dispatch, refetchProfile]
  );

  const logout = useCallback(() => dispatch(dehydrate()), [dispatch]);

  const makeRedirect = useCallback((toLogin = false) => {
    const exceptions = [
      // constant.PAGES.SIGNUP,
      constant.PAGES.PHONE_NUMBER,
      constant.PAGES.VERIFY_PHONE,
      constant.PAGES.VERIFY_EMAIL,
      constant.PAGES.RESET,
      constant.PAGES.TwoFAReset,
      constant.PAGES.FORGOT,
      constant.PAGES.RESET_CODE,
      constant.PAGES.VERIFY_TWO_FA,
      constant.PAGES.GENERATE_TWO_FA,
      constant.PAGES.APP,
      constant.PAGES.TECH_POINT_WIDGET,
      // constant.PAGES.VERIFY_EMAIL_PASSWORD,
    ];
    const currentPagePath = window.location.pathname;

    const navigate = (path) =>
      (window.location = window.location.origin + path);
    const searchParam = new URLSearchParams(window?.location?.search ?? "");

    if (exceptions.includes(currentPagePath)) {
      return;
    }
    if (toLogin && !exceptions.includes(currentPagePath)) {
      // console.log("LOCATION :: to login", window?.location);
      const redirectUrl = currentPagePath;
      currentPagePath !== constant.PAGES.LOGIN &&
        currentPagePath !== "/login" &&
        currentPagePath !== constant.PAGES.SIGNUP &&
        navigate(`${constant.PAGES.LOGIN}?redirectUrl=${redirectUrl}`);
      return;
    }
    if (
      currentPagePath &&
      !searchParam.has("redirectUrl") &&
      currentPagePath !== constant.PAGES.LOGIN &&
      currentPagePath !== constant.PAGES.SIGNUP
    )
      return;

    if (
      searchParam.has("redirectUrl") &&
      !currentPagePath?.includes(searchParam.get("redirectUrl"))
    ) {
      navigate(searchParam.get("redirectUrl"));
      return;
    }

    // if (
    //   currentPagePath !== constant.PAGES.LOGIN &&
    //   currentPagePath !== constant.PAGES.HOME &&
    //   currentPagePath !== currentPagePath &&
    //   !searchParam.has("redirectUrl")
    // ) {
    //   navigate(currentPagePath);
    //   return;
    // }

    // console.log("LOCATION :: absolute", window?.location);

    !currentPagePath?.includes(constant.PAGES.HOME) &&
      navigate(constant.PAGES.HOME);
    return;
  }, []);

  const getTempProfile = () => {
    const tempProfile = ls.get(constant.TEMP_PROFILE);
    return tempProfile;
  };

  const hydrateAuth = useCallback(() => {
    const auth = ls.get(constant.AUTH_TOKEN_KEY);
    if ((auth?.exp && Date.now() > auth?.exp) || !auth?.token) {
      // console.log("GOT HERE");
      logout();
      makeRedirect(true);
      return;
    }
    login(auth.token, auth.exp, true, auth.verification);
    makeRedirect();
    return;
  }, [login, logout, makeRedirect]);

  useEffect(() => {
    // console.log("AUTH FROM STORE ::: ", auth);

    if (!auth?.token) hydrateAuth();
  }, [auth, hydrateAuth]);

  return {
    token: auth?.token,
    isSignedIn: auth?.isSignedIn,
    hasShownPopup: auth?.hasShownPopup,
    login,
    logout,
    profile,
    verification: auth?.verification,
    hydrateToken: (input) => dispatch(hydrateToken({ ...input })),
    updatePopUpShown: (shown) =>
      dispatch(updatePopUpShow({ hasShownPopup: shown })),
    getTempProfile,
    refetchProfile,
  };
};

export default useAuth;
